import { useDispatch } from "react-redux"
import VacanteSlice from "./slice"
import { useCallback, useEffect } from "react"

export const { refresh,setVacancy,setVacancyId } =
	VacanteSlice.actions

export const useRefresh = () => {
	const dispatch = useDispatch()
	const fn = useCallback(() => {
		dispatch(refresh())
	}, [dispatch])
	return {refresh:fn}
}

export const useSetVacancy = (vacancy) => {
	const dispatch = useDispatch()
	useEffect(() => {
		if (!vacancy) return
		dispatch(setVacancy(vacancy))
		dispatch(setVacancyId(vacancy?.id))
	}, [dispatch, vacancy])
}

